<!-- 時間 -->
<template>
  <div class="row">
    <div class="th cell">時間</div>
    <div class="cell">
      {{ displayMfittTime(departure)
      }}<img
        :src="require(`@/assets/img/icon/svg/icon-side-arrow.svg`)"
        class="arrow"
      />{{ displayMfittTime(arrival) }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ViDepartureAndArrival",
  props: {
    departure: {
      type: String,
      required: true,
    },
    arrival: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.block {
  display: table;
  font-size: 13px;
}
.row {
  display: table-row;
}

.cell {
  font-weight: bold;
  display: table-cell;
  padding: 8px;
}
.th {
  font-weight: 100;
  padding-right: 14px;
  color: grey;
  padding-right: 14px;
}
.arrow {
  width: 10px;
  height: auto;
  padding: 0 6px 1px 6px;
}
</style>
